import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es'
import en from 'vuetify/es5/locale/en'
import i18n from '@/plugins/i18n'

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { es, en },
    current: i18n.locale,
  },
  theme: {
    themes: {
      dark: {
        primary: '#eb5e0c',
      },
      light: {
        primary: '#e6007e',
      },
    },
  },
});
